import React from "react";

export const ManageQuest = () => {
  return <div className="container">ManageQuest</div>;
};
